
export function initMobileMenu() {
  const mobileMenuToggler = document.querySelector('.js-toggleMobileMenu');

  const mobileMenu = document.querySelector('.js-mobileMenuContainer');

  const hasSubMenus = document.querySelectorAll('.js-menuItem--submenu');

  let outsideClickActive = false;



  //block of code to close sub menu if clicked outside the menu
  const outsideClickMobileMenuListener = () => {
    if (outsideClickActive) {
      // Hide the menu
      mobileMenu.classList.add('l-mobile');
      outsideClickActive = false;
      document.removeEventListener('click', outsideClickMobileMenuListener);
    }
  };


  // disallow clicks to open submenu from outsideClickActive
  if (hasSubMenus) {
    for (const hasSubMenu of hasSubMenus) {
      hasSubMenu.addEventListener("click", function () { 
        if (outsideClickActive) {
          document.removeEventListener('click', outsideClickMobileMenuListener);
          outsideClickActive = false;
        }
        document.addEventListener('click', outsideClickMobileMenuListener);

        setTimeout(function () {
          outsideClickActive = true;
        }, 500);
    
      }, false);
    }
  }
  

  mobileMenuToggler.addEventListener('click', (e) => {
    e.preventDefault();
    //e.stopPropagation(); //cannot use stopPropogation becuase it cause disruption in sub menu in media page

    if (outsideClickActive) {
      document.removeEventListener('click', outsideClickMobileMenuListener);
      outsideClickActive = false;
    }


    mobileMenu.classList.toggle('l-mobile');

    document.addEventListener('click', outsideClickMobileMenuListener);


    setTimeout(function () {
      outsideClickActive = true;
    }, 500);

  });
}
